module.exports = __webpack_public_path__ + "img/Rectangle_40.52c67c6a.svg";